function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M157.043 92.8358C157.037 104.567 154.074 116.108 148.427 126.391C142.781 136.673 134.633 145.367 124.737 151.667L123.959 152.153C113.785 158.447 102.162 162.015 90.2087 162.513C78.2556 163.012 66.3756 160.424 55.7128 154.999C45.05 149.574 35.9638 141.495 29.3292 131.54C22.6947 121.584 18.7354 110.088 17.8326 98.159C17.6994 96.4008 17.6328 94.6265 17.6328 92.8358C17.6319 90.1616 17.7839 87.4894 18.0882 84.8326C18.2702 83.2363 18.5057 81.6571 18.7946 80.095C20.8331 69.1495 25.4627 58.8513 32.2962 50.0614C39.1297 41.2715 47.9684 34.2455 58.0731 29.5709C68.1779 24.8964 79.2551 22.7091 90.3783 23.1921C101.501 23.6751 112.347 26.8143 122.009 32.3471C123.398 33.1441 124.753 33.9871 126.075 34.8763C126.36 35.0668 126.644 35.2608 126.925 35.4571C126.948 35.4695 126.969 35.4839 126.988 35.5001C133.836 40.2447 139.782 46.173 144.548 53.0065C152.702 64.6858 157.064 78.5917 157.043 92.8358Z",
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.157,
  d: "M2.53027 68.4391C2.53113 60.3543 4.44968 52.385 8.12837 45.1856C11.8071 37.9863 17.141 31.7621 23.6921 27.0244C30.2432 22.2866 37.8247 19.1703 45.814 17.9314C53.8033 16.6925 61.9726 17.3663 69.6509 19.8975C77.3293 22.4287 84.2977 26.7451 89.984 32.4922C95.6703 38.2394 99.9124 45.2533 102.362 52.9582C104.811 60.663 105.398 68.8389 104.074 76.8146C102.75 84.7903 99.5535 92.3382 94.7463 98.8386L102.521 107.474L93.8878 115.246L86.786 107.358C79.3536 113.686 70.2646 117.754 60.5936 119.081C50.9226 120.407 41.0739 118.937 32.212 114.843C23.3501 110.75 15.8456 104.205 10.5857 95.9814C5.32583 87.7581 2.53052 78.2007 2.53027 68.4391H2.53027Z",
  fill: "#1AAB52"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M145.424 143.319C145.389 146.249 144.209 149.049 142.137 151.121C140.065 153.193 137.265 154.373 134.335 154.408C132.799 154.407 131.279 154.098 129.864 153.499C128.449 152.901 127.168 152.025 126.097 150.923L90.6108 112.268C90.3104 111.982 90.0712 111.638 89.9078 111.257C89.7444 110.876 89.6602 110.465 89.6602 110.05C89.6602 109.636 89.7444 109.225 89.9078 108.844C90.0712 108.463 90.3104 108.119 90.6108 107.833L98.8487 99.5946C99.1347 99.2943 99.4788 99.0551 99.86 98.8917C100.241 98.7283 100.652 98.644 101.066 98.644C101.481 98.644 101.892 98.7283 102.273 98.8917C102.654 99.0551 102.998 99.2943 103.284 99.5946L141.939 135.399C143.035 136.407 143.91 137.632 144.509 138.995C145.109 140.358 145.421 141.83 145.424 143.319Z",
  fill: "#B06328"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M141.622 135.082L139.721 133.497C141.343 135.46 142.238 137.922 142.256 140.468C142.256 144.586 137.186 146.171 134.335 143.32L101.067 110.051C100.637 109.6 100.121 109.242 99.5496 108.996C98.9777 108.751 98.362 108.625 97.7399 108.625C97.1177 108.625 96.502 108.751 95.9302 108.996C95.3583 109.242 94.8422 109.6 94.4132 110.051L91.2451 113.219L125.78 150.289C127.639 152.268 130.081 153.601 132.751 154.092C134.42 154.251 136.104 154.051 137.689 153.504C139.274 152.958 140.723 152.078 141.939 150.924C143.093 149.707 143.973 148.258 144.52 146.673C145.066 145.088 145.267 143.404 145.107 141.735C145.107 139.2 143.524 136.983 141.622 135.082Z",
  fill: "#A35425"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M108.988 113.22C108.541 113.267 108.092 113.154 107.72 112.902L99.7995 104.982C99.6493 104.839 99.5298 104.667 99.4481 104.476C99.3663 104.285 99.3242 104.08 99.3242 103.873C99.3242 103.665 99.3663 103.46 99.4481 103.27C99.5298 103.079 99.6493 102.907 99.7995 102.764C99.9425 102.614 100.115 102.494 100.305 102.412C100.496 102.331 100.701 102.289 100.908 102.289C101.116 102.289 101.321 102.331 101.512 102.412C101.702 102.494 101.874 102.614 102.017 102.764L109.938 110.685C110.088 110.828 110.208 111 110.29 111.19C110.371 111.381 110.413 111.586 110.413 111.794C110.413 112.001 110.371 112.206 110.29 112.397C110.208 112.587 110.088 112.759 109.938 112.902C109.938 113.22 109.305 113.22 108.988 113.22Z",
  fill: "#C97629"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M91.5455 106.803L97.8184 100.53L88.4091 91.121L82.1363 97.3939L91.5455 106.803Z",
  fill: "#F0F0F6"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M93.1467 102.13L94.7313 103.715L97.8994 100.546L88.394 91.041L82.0566 97.3783L86.8093 102.13C87.2066 101.682 87.6944 101.323 88.2406 101.077C88.7869 100.831 89.379 100.704 89.978 100.704C90.577 100.704 91.1692 100.831 91.7154 101.077C92.2616 101.323 92.7495 101.682 93.1467 102.13Z",
  fill: "#D8D8EB"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M6.01567 62.5248C6.0159 53.1251 8.80344 43.9366 14.0258 36.1211C19.2482 28.3057 26.6708 22.2143 35.355 18.6174C44.0393 15.0204 53.5951 14.0794 62.8142 15.9134C72.0332 17.7473 80.5014 22.2738 87.1479 28.9205C93.7944 35.5671 98.3207 44.0354 100.154 53.2545C101.988 62.4736 101.047 72.0294 97.4497 80.7136C93.8526 89.3978 87.761 96.8202 79.9455 102.042C72.1299 107.265 62.9413 110.052 53.5416 110.052C47.2979 110.06 41.114 108.837 35.344 106.451C29.574 104.066 24.3314 100.565 19.9165 96.1502C15.5016 91.7352 12.0013 86.4925 9.6159 80.7225C7.23055 74.9524 6.00711 68.7684 6.01567 62.5248Z",
  fill: "url(#paint1_linear)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M53.542 100.545C74.5401 100.545 91.5625 83.5231 91.5625 62.5249C91.5625 41.5268 74.5401 24.5044 53.542 24.5044C32.5438 24.5044 15.5215 41.5268 15.5215 62.5249C15.5215 83.5231 32.5438 100.545 53.542 100.545Z",
  fill: "url(#paint2_linear)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M34.8491 66.9606C35.6253 61.0989 38.3118 55.6563 42.4929 51.4752C46.674 47.2941 52.1165 44.6076 57.9783 43.8314H58.2954C63.6813 43.1983 63.9985 35.5935 58.9286 34.6432C55.7937 34.0634 52.5897 33.9565 49.4232 34.326C43.4391 35.2181 37.9 38.009 33.6222 42.2874C29.3444 46.5658 26.5543 52.1054 25.6631 58.0895C25.1281 61.2465 25.2348 64.479 25.9768 67.5938C26.9271 72.9797 34.5319 72.3465 35.1651 66.9606C34.8491 67.2778 34.8491 66.9606 34.8491 66.9606Z",
  fill: "white",
  fillOpacity: 0.49
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M18.6896 65.6928C18.719 55.6182 22.7342 45.9647 29.858 38.8408C36.9819 31.7169 46.6355 27.7018 56.7101 27.6723C66.0118 27.7733 74.9827 31.1375 82.0571 37.1778C78.489 33.1464 74.0965 29.9286 69.1769 27.7421C64.2573 25.5556 58.9254 24.4514 53.542 24.5043C43.4674 24.5337 33.8138 28.5488 26.6899 35.6727C19.5661 42.7966 15.5509 52.4501 15.5215 62.5248C15.5398 67.8971 16.6761 73.2069 18.858 78.1163C21.0399 83.0257 24.2196 87.4273 28.195 91.041C22.1545 83.9663 18.7903 74.995 18.6896 65.6928Z",
  fill: "#DBDBEB"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.813,
  d: "M90.2423 55.6598C93.5135 76.3138 78.9477 95.3738 58.2937 98.6451C48.5921 100.182 38.334 96.9427 30.5572 92.4003C34.7123 95.8241 39.5545 98.3152 44.756 99.7052C49.9575 101.095 55.3969 101.351 60.7061 100.457C70.6521 98.8516 79.5587 93.3757 85.4804 85.2251C91.4022 77.0745 93.8577 66.9117 92.3108 56.9565C91.4522 51.6532 89.4993 46.5865 86.5763 42.0789C83.6533 37.5713 79.8241 33.7213 75.3324 30.7739C82.0556 36.7664 88.7057 45.9581 90.2423 55.6598Z",
  fill: "white"
});

var _ref14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 17.6328,
  y1: 51.2949,
  x2: 140.196,
  y2: 138,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#67EA9C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#35D371"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 101.068,
  y1: 110.052,
  x2: 14.9505,
  y2: 38.6679,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E8E8F0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F7F7FC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 22.6693,
  y1: 43.4386,
  x2: 91.5625,
  y2: 100.545,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8CF3B6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#66F29E"
})));

var SvgSearchIcon = function SvgSearchIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 180,
    viewBox: "0 0 181 180",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearchIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search-icon.d8615a84.svg";
export { ForwardRef as ReactComponent };